// extracted by mini-css-extract-plugin
export default {"container":"Merchant_container__+gKtE","text_container":"Merchant_text_container__bbvz-","image":"Merchant_image__fBsWV"};